// extracted by mini-css-extract-plugin
export var details = "_kh-0";
export var inspectorPopover = "_kh-1";